import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Project } from '../../../core/models/project.model';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-projects-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './projects-card.html',
  styleUrl: './projects-card.scss',
})
export class ProjectsCard {
  @Input() project!: Project | any;
  @Output() projectClick = new EventEmitter<Project>();

  get id(): string {
    return this.project?.targetId || this.project?.id || this.project?._id || '';
  }

  get name(): string {
    return this.project?.name || this.project?.project?.name || '';
  }

  get developer(): string {
    return this.project?.developer || this.project?.developer?.name || this.project?.owner?.name || '';
  }

  get location(): string {
    return this.project?.location || this.project?.project?.location || '';
  }

  get imageUrl(): string {
    const raw = this.project?.imageUrl || this.project?.thumbnail || this.project?.masterPlan;
    if (!raw) return 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80';
    if (typeof raw === 'object' && raw.secure_url) return raw.secure_url;
    if (typeof raw === 'string') {
      if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:')) {
        return raw;
      }
      const clean = raw.startsWith('/') ? raw : `/${raw}`;
      return `https://api.homigo-eg.com${clean}`;
    }
    return 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80';
  }

  get deliveryDate(): string {
    const raw = this.project?.deliveryDate || this.project?.project?.deliveryDate;
    if (!raw) return '';
    if (typeof raw === 'string' && raw.includes('T')) {
      const year = raw.split('-')[0];
      return year || raw.split('T')[0];
    }
    return String(raw);
  }

  get unitTypes(): string[] {
    if (Array.isArray(this.project?.unitTypes) && this.project.unitTypes.length > 0) {
      return this.project.unitTypes;
    }
    const pType = this.project?.project?.type || this.project?.type;
    if (pType && pType !== 'project') {
      return [String(pType)];
    }
    return [];
  }

  get startingPrice(): number {
    const p = this.project?.startingPrice ?? this.project?.project?.priceStart ?? this.project?.price?.salePrice?.basePrice;
    return typeof p === 'number' ? p : Number(p) || 0;
  }

  get currency(): string {
    return this.project?.currency || 'EGP';
  }

  get totalUnits(): number {
    const u = this.project?.totalUnits ?? this.project?.project?.plannedUnits;
    return typeof u === 'number' ? u : Number(u) || 0;
  }

  get rating(): number {
    return this.project?.rating || 0;
  }

  get totalReviews(): number {
    return this.project?.totalReviews || 0;
  }

  get isFeatured(): boolean {
    return Boolean(this.project?.isFeatured);
  }

  get isTrusted(): boolean {
    return Boolean(this.project?.isTrusted);
  }

  get isFavorite(): boolean {
    return Boolean(this.project?.isFavorite);
  }

  toggleFavorite(event: MouseEvent) {
    event.stopPropagation();
    if (this.project) {
      this.project.isFavorite = !this.project.isFavorite;
    }
  }

  onClick() {
    this.projectClick.emit(this.project);
  }
}
